// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3VGz4","content":"LayoutSettings_content__21QyG"};